export const css = {
    root: '_3wbufzqI',
    question: 'MsU0FJj5',
    feedback: 'MpY_aqpX',
    rationale: '_3eod_5vU',
    fmi: '_1A0oxq8y',
    distractorBlock: '_1mbT5XXp',
    distractorFieldset: 'q_1X_r7t',
    distractorLegend: '_2jkMqFxT',
    distractor: '_3sD6PLyh',
    distractorLabel: 'bXZP0TpW',
    distractorWithFlag: '_3NHxERBu',
    distractorHint: 'kBqiXvoh',
    actions: 'Unp8ZMtT',
    oneaction: 'NuBzZFUk',
    markblock: 'aF9f9qAn',
    timerblock: 'wDOagNUj',
    timer: 'JILjEmxc',
    pressed: '_2mRx0wtA',
    actionIcon: 'aavqsHT0',
    primaryButton: '_26cH6qwE',
    secondaryButton: 'FwN3HBRB',
    ' _key': 'quiz-widgets/mcquestion'
};
export default css;
